import bodyScrollClass from './bodyScrollClass.js';
import MainNavigation from './mainNavigation.js';
import NewsListSearch from './NewsListSearch.js';
import WidgetNavigation from './widgetNavigation';
import ResponsiveTable from './ResponsiveTable.js';
import TextWithVideo from './TextWithVideo';
import TextWithMap from './TextWithMap';
import accordion from './accordion';
import HighlightTeaser from './HighlightTeaser.js';
import ImageCarousel from './ImageCarousel.js';
import JumpNavigation from './JumpNavigation.js';
import NewsletterToggle from './NewsletterToggle.js';
import { TravelsList } from './TravelsList.js';
import TravelsTeaser from './TravelsTeaser.js';
import TravelShowInpageNavigation from './TravelShowInpageNavigation.js';
import BookingForm from './BookingForm.js';

document.addEventListener('DOMContentLoaded', event => {
  bodyScrollClass();

  new ResponsiveTable();

  $('.newsletter-toggle').each((index, elm) => {
    new NewsletterToggle($(elm), {});
  });

  $('.highlight-teaser').each((index, elm) => {
    new HighlightTeaser($(elm));
  });

  new MainNavigation({
    toggleElement: $('.main-navigation__toggle'),
    navigationElement: $('.main-navigation__modal')
  });

  $('.text-with-video').each((index, item) => {
    new TextWithVideo($(item));
  });

  $('.text-with-map').each((index, item) => {
    new TextWithMap($(item));
  });

  $('.image-carousel').each((index, item) => {
    new ImageCarousel($(item));
  });

  $('.jump-navigation').each((index, item) => {
    new JumpNavigation($(item));
  });

  document.querySelectorAll('.travels-list').forEach((element) => {
    new TravelsList(element);
  });

  $('.travels-teaser').each((index, item) => {
    new TravelsTeaser($(item));
  });

  new TravelShowInpageNavigation();

  document.querySelectorAll('.travels-booking-form__form').forEach((form) => {
    new BookingForm(form);
  });

});
